<template>
    <div class="space-y-6">
        <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
            <div class="md:grid md:grid-cols-3 gap-3">
                <div class="md:col-span-1">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">{{ t('setMetaData.body:headline') }}</h3>
                    <div class="mt-6 p-3">
                        <img class="rounded mx-auto" :src="nft.localFileUrl" alt="" />
                    </div>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">
                    <Basic ref="basicForm" v-if="nft.metaDataType === 'basic'" :nft="nft"></Basic>
                    <Poem ref="poemForm" v-if="nft.metaDataType === 'poem'" :nft="nft"></Poem>
                    <HumanObituary ref="humanObituaryForm" v-if="nft.metaDataType === 'human-obituary'" :nft="nft"></HumanObituary>
                    <Animal ref="animalForm" v-if="nft.metaDataType === 'animal'" :nft="nft"></Animal>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import Basic from "./MetaData/Basic";
import Poem from "./MetaData/Poem";
import HumanObituary from "./MetaData/HumanObituary";
import Animal from "./MetaData/Animal";
import translate from "../../lang";
import {computed, ref} from "vue";

const props = defineProps({
            nft: Object,
            nftMetas: Array,
            countries: Object,
            industries: Object,
            employees: Object,
            legalForms: Object,
            specialties: Object,
            verify: Boolean,
        });

const basicForm = ref(null);
const humanObituaryForm = ref(null);
const animalForm = ref(null);
const poemForm = ref(null);

const t = translate('upload-' + props.nft.metaDataType);

let currentForm = computed(() => {
    if(props.nft.metaDataType === 'basic') {
        return basicForm.value.form;
    } else if(props.nft.metaDataType === 'human-obituary') {
        return humanObituaryForm.value.form;
    } else if(props.nft.metaDataType === 'animal') {
        return animalForm.value.form;
    } else if(props.nft.metaDataType === 'poem') {
        return poemForm.value.form;
    }
});

defineExpose({ form: currentForm });

</script>
